import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../../utils/const/estilos-const";
import "../../../../style/style-cargando.css";
import ArrowBack from "../../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useToast, useProcessing } from "../../../../context/ui-feedback-context";
import { actualizarAccionesKanban, crearAccionesKanban } from "../../../../api/api-acciones-kanban";
import {
  crearAccionesKanbanUsuario,
  eliminarAccionesKanbanUsuario,
  obtenerListaAccionesKanbanUsuario,
} from "../../../../api/api-acciones-kanban-usuario";
import { obtenerListaUsuarioWeb } from "../../../../api/api-usuario-web";
import SendRequestComponent from "../../../../components/btn-request";

export default function AccionesKanbanViajePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  const { showToast } = useToast();
  const { showProcessing, hideProcessing } = useProcessing();

  const [sendRequest, setSendRequest] = useState(false);

  const [listaUsuariosWeb, setListaUsuariosWeb] = useState([]);
  const [usuariosSelected, setUsuariosSelected] = useState([]);
  // Map<idUsuario, idAccionKanbanUsuario> — necesario para el eliminar al hacer diff en save
  const [usuariosAsignadosMap, setUsuariosAsignadosMap] = useState({});


  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      const usuarios = await obtenerListaUsuarioWeb({ habilitado: 1 }, false, t);
      const usuariosOptions = (Array.isArray(usuarios) ? usuarios : []).map((u) => ({
        value: u.id,
        label: u.nombreUsuario ?? u.descripcion ?? String(u.id),
      }));
      setListaUsuariosWeb(usuariosOptions);

      if (data?.params?.id && data.params.id !== 0) {
        const asignados = await obtenerListaAccionesKanbanUsuario({
          idAccionKanban: data.params.id,
        });
        const optionByValue = new Map(usuariosOptions.map((o) => [String(o.value), o]));
        const map = {};
        const selected = [];
        (Array.isArray(asignados) ? asignados : []).forEach((row) => {
          map[row.idUsuario] = row.idAccionKanbanUsuario;
          const opt = optionByValue.get(String(row.idUsuario)) ?? {
            value: row.idUsuario,
            label: row.nombreUsuario ?? String(row.idUsuario),
          };
          selected.push(opt);
        });
        setUsuariosAsignadosMap(map);
        setUsuariosSelected(selected);
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const sincronizarUsuariosAsignados = async (idAccionKanban) => {
    const selectedIds = new Set((usuariosSelected ?? []).map((u) => u.value));
    const previousIds = new Set(Object.keys(usuariosAsignadosMap));

    const toAdd = [...selectedIds].filter((id) => !previousIds.has(id));
    const toRemove = [...previousIds].filter((id) => !selectedIds.has(id));

    const addCalls = toAdd.map((idUsuario) =>
      crearAccionesKanbanUsuario({ idAccionKanban, idUsuario })
    );
    const removeCalls = toRemove.map((idUsuario) =>
      eliminarAccionesKanbanUsuario({
        idAccionKanbanUsuario: usuariosAsignadosMap[idUsuario],
      })
    );

    const results = await Promise.all([...addCalls, ...removeCalls]);
    const anyError = results.some((r) => r?.error === true);
    return { error: anyError };
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
    orden: 3,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let next = value;

    if (name === "orden") {
      next = value.replace(/\D/g, "");
    }

    const limit = charLimits[name];
    if (limit == null || next.length <= limit) {
      setFormData({
        ...formData,
        [name]: next,
      });
    }
  };

  const handleColorChange = (e) => {
    let { value } = e.target;

    if (value === '') {
      setFormData({
        ...formData,
        color: value,
      });
      return;
    }

    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    const hexPart = value.substring(1);
    if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && value.length <= 7) {
      setFormData({
        ...formData,
        color: value.toUpperCase(),
      });
    }
  };

  const handleColorPickerChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      color: value.toUpperCase(),
    });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        showToast(message, "error");
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const handleSaveClick = async () => {
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.idKanban = formData.idKanban;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.color = formData.color;
    showProcessing();
    if (formData.id === 0) {
      const response = await crearAccionesKanban(objEnviar);
      if (response.error === true) {
        hideProcessing();
        showToast(t("alert_no_se_pudo_crear"));
        return;
      }
      const nuevoId = response.id;
      if (nuevoId && usuariosSelected.length > 0) {
        const results = await Promise.all(
          usuariosSelected.map((u) =>
            crearAccionesKanbanUsuario({
              idAccionKanban: nuevoId,
              idUsuario: u.value,
            })
          )
        );
        const anyError = results.some((r) => r?.error === true);
        hideProcessing();
        if (anyError) {
          showToast(t("alert_accion_creada_usuarios_error"), "warning", 3500);
        } else {
          showToast(t("alert_se_creo_correctamente"));
        }
        handleCancelClick();
        return;
      }
      hideProcessing();
      showToast(t("alert_se_creo_correctamente"));
      handleCancelClick();
    }
    if (formData.id !== 0) {
      const response = await actualizarAccionesKanban(objEnviar);
      if (response.error === true) {
        hideProcessing();
        showToast(t("alert_no_se_pudo_modificar"));
        return;
      }
      const syncResp = await sincronizarUsuariosAsignados(formData.id);
      hideProcessing();
      if (syncResp.error === true) {
        showToast(t("alert_accion_modificada_usuarios_error"), "warning", 3500);
      } else {
        showToast(t("alert_se_modifico_correctamente"));
      }
      handleCancelClick();
    }
  };

  const render = () => {
    try {
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="color"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_color")}
                </label>
                <div className="flex flex-row items-center gap-2 mt-1">
                  <input
                    id="color"
                    name="color"
                    type="text"
                    value={formData.color || '#000000'}
                    onChange={handleColorChange}
                    className={`${ESTILO_INPUT_GENERICO} flex-1 min-w-0`}
                    placeholder="#FF00FF"
                    maxLength={7}
                  />
                  <input
                    type="color"
                    value={formData.color || '#000000'}
                    onChange={handleColorPickerChange}
                    className="h-10 w-16 shrink-0 cursor-pointer border border-gray-300 rounded"
                    title={t("label_seleccionar_color")}
                  />
                </div>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-8 xl:col-span-8">
                <label
                  htmlFor="usuarios"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_usuarios_permitidos")}
                </label>
                <Select
                  inputId="usuarios"
                  isMulti
                  isSearchable
                  isClearable
                  options={listaUsuariosWeb}
                  value={usuariosSelected}
                  onChange={(selected) => setUsuariosSelected(selected ?? [])}
                  placeholder={t("placeholder_seleccione_usuarios")}
                  noOptionsMessage={() => t("label_sin_datos")}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <SendRequestComponent
                    loading={sendRequest}
                    label={t("label_guardar")}
                    onClick={handleSaveClick}
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
